import { TIPO_REFERENCIAS, TIPO_REFERENCIAS_LABORALES } from './TIPO_REFERENCIAS'

export default class ReferenciaEntity {
  id
  nombre
  telefono
  cargo
  corporacion
  tiempoLaborado
  tipo
  tiempoConocerse
  comoConocio
  fk_idmunicipio
  colonia
  calle
  exterior
  interior
  entrecalles
  referencias
  lat
  lgt
  cp
  entrecalles2
  localidad
  fecharegistro
  municipio
  estado
  idDireccion
  idReferenciasDetalleLabor
  vigente

  constructor(tipo = TIPO_REFERENCIAS.VECINAL) {
    this.id = null
    this.nombre = ''
    this.telefono = ''
    this.cargo = ''
    this.corporacion = ''
    this.tiempoLaborado = 0
    this.tipo = tipo
    this.tiempoConocerse = 0
    this.comoConocio = ''
    this.fk_idmunicipio = 0
    this.colonia = ''
    this.calle = ''
    this.exterior = ''
    this.interior = ''
    this.entrecalles = ''
    this.referencias = ''
    this.lat = null
    this.lgt = null
    this.cp = ''
    this.entrecalles2 = ''
    this.localidad = ''
    this.fecharegistro = new Date()
    this.municipio = ''
    this.estado = ''
    this.idDireccion = null
    this.idReferenciasDetalleLabor = null
    this.vigente = true
  }

  fromDto(referenciaDto) {
    this.id = referenciaDto.idReferencia
    this.nombre = referenciaDto.nombre
    this.telefono = referenciaDto.telefono
    this.tipo = referenciaDto.fk_idCatTipoReferencia
    this.idDireccion = referenciaDto.fk_idDireccion
    this.idReferenciasDetalleLabor = referenciaDto.fk_idReferenciasDetalleLabor
    this.vigente = referenciaDto.vigente ?? true

    if (TIPO_REFERENCIAS_LABORALES.includes(referenciaDto.fk_idCatTipoReferencia)) {
      this.cargo = referenciaDto.referenciasDetalleLabor?.cargo ?? ''
      this.corporacion = referenciaDto.referenciasDetalleLabor?.corporacion ?? ''
      this.tiempoLaborado = referenciaDto.referenciasDetalleLabor?.tiempoLaborado ?? 0
    }

    if (referenciaDto.fk_idCatTipoReferencia === TIPO_REFERENCIAS.PERSONAL) {
      this.tiempoConocerse = referenciaDto.tiempoConocerse ?? 0
      this.comoConocio = referenciaDto.comoConocerse ?? ''
    }

    if (referenciaDto.fk_idCatTipoReferencia === TIPO_REFERENCIAS.VECINAL && referenciaDto.direccion) {
      this.tiempoConocerse = referenciaDto.tiempoConocerse ?? 0
      this.fk_idmunicipio = referenciaDto.direccion.fk_idmunicipio ?? 0
      this.colonia = referenciaDto.direccion.colonia ?? ''
      this.calle = referenciaDto.direccion.calle ?? ''
      this.exterior = referenciaDto.direccion.ext ?? ''
      this.interior = referenciaDto.direccion.int ?? ''
      this.entrecalles = referenciaDto.direccion.entrecalles ?? ''
      this.referencias = referenciaDto.direccion.referencias ?? ''
      this.lat = referenciaDto.direccion.lat ?? null
      this.lgt = referenciaDto.direccion.lgt ?? null
      this.cp = referenciaDto.direccion.cp ?? ''
      this.entrecalles2 = referenciaDto.direccion.entrecalles2 ?? ''
      this.localidad = referenciaDto.direccion.localidad ?? ''
      this.fecharegistro = referenciaDto.direccion.fecharegistro ?? new Date()
      this.municipio = referenciaDto.direccion?.catMunicipio?.nombre ?? ''
      this.estado = referenciaDto.direccion?.catMunicipio?.catEstado?.title ?? ''
    }

    return this
  }
}
